export const dataHooks = {};
